import axios from "axios";
//import moment from "moment";
const { MOMMYVUE_API_URL } = (window as any).env

export const axiosHelper = axios.create({
  baseURL: MOMMYVUE_API_URL
});

export const axiosHelperWithToken = () => {
  // // Check if auth token expired
  let authToken = sessionStorage.getItem('authToken');
  // const decodedJwt = parseJwt(authToken);
  // if (moment(decodedJwt.exp * 1000) < moment().add(-5, 'minutes')) {
  //   //Expired
  //   getRefreshToken()
  // }
  // //
  const axiosInstance = axios.create({
    baseURL: MOMMYVUE_API_URL,
    headers: {
      Authorization: 'Bearer ' + authToken
    }
  });
  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            const rs = await getRefreshToken();
            const { jwtToken } = rs.data;
            if (jwtToken) {
              sessionStorage.setItem('authToken', jwtToken);
            }
            originalConfig.headers["Authorization"] = 'Bearer ' + jwtToken;
            axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + jwtToken;
            return axiosInstance(originalConfig);
          } catch (_error: any) {
            if (_error.response && _error.response.data) {
              return Promise.reject(_error.response.data);
            }
            return Promise.reject(_error);
          }
        }
        if (err.response.status === 403 && err.response.data) {
          return Promise.reject(err.response.data);
        }
      }
      return Promise.reject(err);
    });
  return axiosInstance
}
// export const parseJwt = (token: string | null) => {
//   try {
//     return token ? JSON.parse(atob(token.split(".")[1])) : null;
//   } catch (e) {
//     return null;
//   }
// }
export const getRefreshToken = () => {
  return axios.post(`${MOMMYVUE_API_URL}/Users/refresh-token`)
}